import BankApplicationsList from '@/components/bankAccountApplications/BankApplicationsList';
import { SVLoader, SVListFilters, SVListPagination } from '@/components/core';
import DefaultLayout from '@/components/layouts/DefaultLayout';
import { FILTERS } from '@/constants/filters';
import { useGetBankApplicationsList } from '@/hooks/requests/useBankApplications';
import useBuildListFilters from '@/hooks/requests/useBuildListFilters';
import { BankApplicationStatus } from '@/types/bankApplications';
import { Card, Typography, Stack } from '@mui/material';

export default function BankApplicationsSubmittedPage() {
  const {
    bankApplications,
    isBankApplicationsPending,
    isSuccess,
    totalRecordCount,
  } = useGetBankApplicationsList([
    BankApplicationStatus.SUBMITTED,
    BankApplicationStatus.SUBMITTED_BY_STAFF,
    BankApplicationStatus.SUBMITTED_BY_TEAMMATE,
  ]);
  const { defaultValues, filters } = useBuildListFilters({
    enabled: isSuccess,
    extraFilters: [FILTERS.ACCOUNT_TYPE],
    hasCompanyFilter: true,
    hasTeammateFilter: true,
    hasCustomerFilter: true,
  });
  const header = `Bank Account Applications - Submitted ${totalRecordCount ? `(${totalRecordCount})` : ''}`;

  if (isBankApplicationsPending) {
    return (
      <DefaultLayout header={header}>
        <Card>
          <SVLoader />
        </Card>
      </DefaultLayout>
    );
  }

  return (
    <DefaultLayout header={header}>
      <SVListFilters
        defaultValues={defaultValues}
        filters={filters}
        searchLabel="Search by owner email or application ID"
      />
      {isBankApplicationsPending ? (
        <SVLoader />
      ) : (
        <>
          {bankApplications.length === 0 ? (
            <Card>
              <Typography>No results found</Typography>
            </Card>
          ) : (
            <Stack spacing={2}>
              <BankApplicationsList bankApplications={bankApplications} />
              <SVListPagination totalRecordCount={totalRecordCount} />
            </Stack>
          )}
        </>
      )}
    </DefaultLayout>
  );
}
